// Shared trait handling for the platform-specific Ours clients (ours.web.ts /
// ours.native.ts). The set of traits that map to first-class Ours visitor
// fields lives here so the two implementations can't diverge; each platform
// only maps this canonical shape onto its SDK's key casing.
export interface CanonicalTraits {
  email?: string;
  firstName?: string;
  lastName?: string;
  phone?: string;
  state?: string;
  custom: Record<string, unknown>;
}

export const splitTraits = (
  traits: Record<string, unknown> = {},
): CanonicalTraits => {
  const { email, firstName, lastName, phone, state, ...custom } = traits;
  const str = (value: unknown) => (value == null ? undefined : String(value));
  return {
    email: str(email),
    firstName: str(firstName),
    lastName: str(lastName),
    phone: str(phone),
    state: str(state),
    custom,
  };
};
